import Rebase from 're-base';

const base = Rebase.createClass({
    apiKey: "AIzaSyAkTk-P5E9d2QIcPlR9DwTu6V8I-s43OfA",
    authDomain: "fish-store-wes-bos.firebaseapp.com",
    databaseURL: "https://fish-store-wes-bos.firebaseio.com"
});

export default base;



/** WEBPACK FOOTER **
 ** ./src/base.js
 **/